import { BaseTransactionModel } from '@shared/app/scripts/classes/base-transaction-model';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Injectable } from 'angular-ts-decorators';
import type { IStandardErrorParser } from './standard-error-parser';
import type { IConfig } from './config';
import { Domain } from './domain';

/**
 * # Retail Transactions
 *
 * This service is used to interface with the /retail-transactions/get spynl endpoint
 * The endpoint can return a sale, transit, or consignment and has various filters
 * that can be applied to requests.
 */
@Injectable('retailTransactions')
export class RetailTransactions extends SpynlBase<BaseTransactionModel> {
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';
    super(
      $http,
      $q,
      sentry,
      domain,
      config,
      standardErrorParser,
      BaseTransactionModel,
    );
    this.location = '/retail-transactions';
  }
}
